import { Field, Form, Formik } from 'formik'
import React, { useContext, useEffect, useState } from 'react'
import SubmitButton from '../components/SubmitButton'
import * as yup from "yup";
import { MyContext } from '../context/MyContext';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import { MenuActive } from '../context/MenuActiveContext';
import usePost2 from '../customHooks/usePost2';
import useFetch from '../customHooks/useFetch';
import axios from 'axios';
import config from "../services/config.json";
import { getTokenSession } from '../utils/common';

const Setting = () => {
  const { rolesData } = useContext(MyContext);
  const { setMunuActiv } = useContext(MenuActive);
    const {loading,data} = useFetch("settings")
    const [datas, setDatas] = useState([])
  useEffect(() => {
   if(data) {
    setDatas(data.data)
   }
  }, [data])
  useEffect(() => {
    setMunuActiv([true,"Settings"])
  }, [setMunuActiv])

  const [res, apiMethod] = usePost()
  const initialValues = {
    old_password: "",
    new_password: "",
    email: rolesData?.email,
  };

  const validationSchema = yup.object({
    old_password: yup
      .string()
      .min(6, "Mininum 6 length")
      .max(20, "Maximum 20 length")
      .required("Must Required"),
      new_password: yup
      .string()
      .min(6, "Mininum 6 length")
      .max(20, "Maximum 20 length")
      .required("Must Required")
  });

  const validationSchema2 = yup.object({
    product_upload_charges: yup
      .string().required("Must Required"),
  });
  const handleSubmit = async (values,{ resetForm }) => {
    let formdata = new FormData();
    for (let item in values) {
      formdata.append(item,values[item])
    }
    apiMethod(`changeVendorPassword`,formdata);
    resetForm();
  }
  useEffect(() => {
    if(res.data) {
      if(res.data.status === "false") {
        toast.error(res.data.message);
      }
      else {
        toast.success(res.data.message);
      }
    }
   
  }, [res.data])
    const [res2, apiMethod2] = usePost2()
const handleSubmit2 = async () => {
  for (let item of datas) {
    const { key, value } = item;

    if (key && value) {
      await apiMethod2("settings", { key, value });
    }
  }
};
useEffect(() => {
  if (res2.data) {
    if (res2.data.status === "false") {
      toast.error(res2.data.message);
    } else {
      toast.success(res2.data.message);
    }
  }
}, [res2.data]);


  if(loading) return ""



  return (
    <div className='setting'>
        <div className="h4 font-medium mb-4">Settings</div>

        <div className="settingBox py-10 px-10">

            <div className="h5 font-medium mb-3 ">Reset Password</div>
            <Formik initialValues={initialValues}  
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnChange>
                <Form>
            <Field name={"old_password"} type="password" className="settingBox_input mb-3" placeholder="Old Password" />
            <Field name={"new_password"} type="password" className="settingBox_input" placeholder="New Password" />
            <SubmitButton
                 props={{
                    class: "btn btn-primary  block mt-5 submit",
                    text: "Submit",
                  }}
                //  buttonLoading={res.isLoading}
                />
                </Form>
            </Formik>
        </div>
<div className="settingBox mt-7 py-10 px-10">
  <div className="text-lg font-medium mb-5">Product Upload Charges</div>

  {Array.isArray(datas) &&
    datas.map((item) => {
      const { id, key, value } = item;
        const authentication = getTokenSession();
        let headers = {
          "Content-Type": "application/json",
        }
        if(authentication) {
         headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authentication}`,
        };
      } 
            const handleSingleSubmit = async () => {
        if (!key || !value) {
          toast.error("Key and Value are required");
          return;
        }

        const payload = { key, value };
       try {
    const response = await axios.put(`${config.apiEndPoint}settings/${id}`, payload,{
        headers,
      }); // replace with your actual URL if needed

    if (response?.data?.status === "false") {
      toast.error(response.data.message || "Error while saving");
    } else {
      toast.success(response.data.message || "Saved successfully");
    }
  } catch (error) {
    toast.error("API error occurred");
    console.error(error);
  }
      };
      return (
        <div key={id} className="flex flex-wrap items-end gap-4 mb-4">
          {/* Key Input */}
          <div className="flex-1 min-w-[200px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">Key</label>
            <input  type="text"  value={key}  disabled  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Value Input */}
          <div className="flex-1 min-w-[200px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">Value</label>
            <input
              type="text"
              value={value}
              onChange={(e) =>
                setDatas((prevData) =>
                  prevData.map((dataItem) =>
                    dataItem.id === id ? { ...dataItem, value: e.target.value } : dataItem
                  )
                )
              }
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Submit Button */}
          <div>
            <button
              disabled={res2.isLoading}
               onClick={handleSingleSubmit}
              className={`btn btn-primary px-6 py-2 rounded-md text-white `}>
              Submit
            </button>
          </div>
        </div>
      );
    })}
</div>

    </div>
  )
}

export default Setting